export const SETTINGS_DATA_ATTRIBUTE_IDS = {
  Languages: {
    English: 'Account.Settings.Languages.English',
    Chinese: 'Account.Settings.Languages.Chinese'
  },
  Billing: {
    UpdatePayment: 'Account.Settings.Billing.UpdatePaymentMethod',
    UpdatePaymentConfirm: 'Account.Settings.Billing.UpdatePaymentConfirm',
    UpdatePaymentCancel: 'Account.Settings.Billing.UpdatePaymentCancel',
    AddCompanyDetails: 'Account.Settings.Billing.AddCompanyDetails',
    DownloadInvoice: 'Account.Settings.Billing.DownloadInvoice',
    EmailInvoice: 'Account.Settings.Billing.EmailInvoice',
    InvoiceMenuIcon: 'Account.Settings.Billing.InvoiceMenuIcon',
    InvoiceMenuDownload: 'Account.Settings.Billing.InvoiceMenuDownload',
    InvoiceMenuEmail: 'Account.Settings.Billing.InvoiceMenuEmail',
    InvoiceNumber: 'Account.Settings.Billing.InvoiceNumber'
  }
}
